import { motion, AnimatePresence, Variants } from 'framer-motion';
import { memo } from 'react';
import GameBattle from '@/components/CaseBattles/Game/GameBattle';
import { casebattlesStore } from '@/stores/casebattles.store';

const animationVariants: Variants = {
    hidden: { opacity: 0, y: 16, scale: 0.97 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.35, ease: 'easeOut' } },
    exit: { opacity: 0, y: -12, scale: 0.97, transition: { duration: 0.25, ease: 'easeIn' } },
};

const GamesList = memo(() => {
    const { historyGames, activeGames } = casebattlesStore((state) => state);
    const active = activeGames();
    const history = historyGames();

    return (
        <div className="flex flex-col gap-4">
            {active.length === 0 && history.length === 0 ? (
                <div className="surface text-center text-text_3 text-sm py-16 px-4">
                    No active battles. Be the first to create one.
                </div>
            ) : (
                <>
                    {active.length > 0 && (
                        <div className="flex flex-col gap-2.5">
                            <AnimatePresence mode="popLayout">
                                {active.map(
                                    (game) =>
                                        game && (
                                            <motion.div
                                                key={`${game.status}_${game.id}`}
                                                variants={animationVariants}
                                                initial="hidden"
                                                animate="visible"
                                                exit="exit"
                                                layout
                                            >
                                                <GameBattle game={game} />
                                            </motion.div>
                                        )
                                )}
                            </AnimatePresence>
                        </div>
                    )}

                    {history.length > 0 && (
                        <>
                            <div className="text-[11px] uppercase tracking-[0.12em] text-text_4 font-bold pt-2">
                                Recent battles
                            </div>
                            <div className="flex flex-col gap-2.5">
                                <AnimatePresence mode="popLayout">
                                    {history.map(
                                        (game) =>
                                            game && (
                                                <motion.div
                                                    key={game.id}
                                                    variants={animationVariants}
                                                    initial="hidden"
                                                    animate="visible"
                                                    exit="exit"
                                                    layout
                                                >
                                                    <GameBattle game={game} />
                                                </motion.div>
                                            )
                                    )}
                                </AnimatePresence>
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
});

export default GamesList;
